module.exports = require("@aofl/store");